<template>
  <div class="main">
    <div class="content">
      <!-- 公告模块 -->
      <div class="notice-box">
        <div class="notice-left">
          <van-notice-bar :speed="20">
            <template slot="left-icon">
              <div class="notice-img">
                <img class="horn" src="@/assets/mobile/image/home/horn.png" />
              </div>
            </template>
            <template slot="default">
              <div class="default-box">
                <div
                  class="default-item"
                  v-for="(item, index) in changesList"
                  :key="index"
                >
                  <img
                    class="default-img"
                    @error="error"
                    :src="item.avatarUrl"
                  />
                  <div class="tel-number">{{ item.userName }}</div>
                  <div class="dateline">{{ item.dateline | getNewTime }}</div>

                  <div class="amount">
                    兑换了<span>{{ `${item.amount}元` }}</span>
                  </div>
                </div>
              </div>
            </template>
          </van-notice-bar>
        </div>
        <img
          class="chat"
          @click="goto('/mobile/allNews')"
          src="@/assets/mobile/image/home/chat.png"
        />
      </div>
      <!-- 快捷导航 -->
      <div class="quick-navigation">
        <img class="bg1" src="@/assets/mobile/image/home/bg1.png" />

        <div class="quick-card">
          <div
            class="quick-item"
            @click="gourl(item.path)"
            v-for="item in quickList"
            :key="item.name"
          >
            <img class="iocn" :src="item.url" />
            <div class="name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 推荐任务 -->
    <div class="task-list">
      <div class="task-herder">
        <div class="task-herder-left">推荐任务</div>
        <div class="task-herder-right" @click="goto('/mobile/task')">更多</div>
      </div>
      <div
        class="task-item"
        v-for="(item, index) in list"
        :key="index"
        @click="goUrl(item.encryptId)"
      >
        <div class="task-left">
          <img class="edit" src="@/assets/mobile/image/home/edit.png" />
          <div class="text-box">
            <div class="text-top">{{ item.title }}</div>
            <div class="img-bottom">
              <img
                class="star"
                v-for="cItem in Math.floor(item.IR / 20)"
                :key="cItem"
                src="@/assets/mobile/image/home/star-s.png"
              />
              <img
                class="star"
                v-for="cItem in 5 - Math.floor(item.IR / 20)"
                :key="cItem + Math.floor(item.IR / 20) + 1"
                src="@/assets/mobile/image/home/star-k.png"
              />
            </div>
          </div>
        </div>
        <div class="task-right">
          <div class="shang">
            <img
              v-if="item.deviceType === 2 || item.deviceType === 1"
              src="@/assets/image/homepage/pc.png"
            />
            <img
              v-if="item.deviceType === 1 || item.deviceType === 3"
              src="@/assets/image/homepage/phone.png"
            />
          </div>
          <div class="number-box">
            <span class="number">{{ item.minPoints }}~{{ item.maxPoints }}</span
            >金币
          </div>
        </div>
      </div>

      <div class="empty-box" v-if="list.length === 0">
        <el-empty description="暂无数据"></el-empty>
      </div>
    </div>

    <Tabbar :active="1"></Tabbar>
  </div>
</template>

<script>
import Tabbar from "@/components/tabbar.vue";
import {
  getIndividualSurveys,
  getExchangeHistory,
  getWeChatAuthWechatUrl,
} from "@/api/mobile";
import { generateUUID } from "@/utils/replace";
export default {
  filters: {
    getNewTime(data) {
      let name = "";
      // 获取当前时间的时间戳
      const now = new Date();
      const nowTimestamp = now.getTime();

      // 示例目标时间
      const targetDate = new Date(data); // 可以替换为任何你想要计算的时间
      const targetTimestamp = targetDate.getTime(); // 获取目标时间的Unix时间戳

      // 计算差值并转换为分钟
      const differenceInMilliseconds = nowTimestamp - targetTimestamp; // 计算两个时间戳的差值（毫秒）
      const differenceInMinutes = parseInt(
        differenceInMilliseconds / (1000 * 60)
      ); // 将差值转换为分钟

      if (differenceInMinutes === 0) {
        name = "刚刚";
      }
      if (differenceInMinutes < 60 && differenceInMinutes > 0) {
        name = differenceInMinutes + "分钟前";
      }

      if (differenceInMinutes > 60) {
        let hours = parseInt(differenceInMinutes / 60);
        if (hours < 24) {
          name = hours + "小时前";
        } else {
          let day = parseInt(hours / 24);
          name = day + "天前";
        }
      }
      return name;
    },
  },
  data() {
    return {
      quickList: [
        {
          name: "每日任务",
          url: require("@/assets/mobile/image/home/iocn-1.png"),
          path: "/mobile/dailyTasks",
        },
        {
          name: "卡券专区",
          url: require("@/assets/mobile/image/home/iocn-2.png"),
          path: "/mobile/coupon",
        },
        {
          name: "好友邀请",
          url: require("@/assets/mobile/image/home/iocn-3.png"),
          path: "/mobile/invite",
        },
        {
          name: "签到有礼",
          url: require("@/assets/mobile/image/home/iocn-4.png"),
          path: "/mobile/signIn",
        },
      ],
      list: [],
      changesList: [],
      timer: null,

      weixinFlag: false,
    };
  },
  components: { Tabbar },
  methods: {
    gourl(path) {
      this.$router.push(path);
    },
    error(e) {
      e.target.src = require("@/assets/image/module/head.png");
    },

    //获取任务列表
    async getIndividualSurveys() {
      await getIndividualSurveys().then((res) => {
        if (res.code === 200) {
          console.log("res", res);
          this.list = res.data.list;
        }
      });
    },
    goUrl(id) {
      this.$router.push(`/mobile/taskDetails?id=${id}`);
    },

    goto(path) {
      this.$router.push(path);
    },
  },
  async created() {
    //微信自动登录
    if (this.$route.query.from && this.$route.query.from === "wechat") {
      this.weixinFlag = true;
      let state = generateUUID();
      let redirectUrl =
        "https://www.aidajuan.com/mobile/landingPage?url=" + "/mobile/home";
      await getWeChatAuthWechatUrl({
        redirectUrl,
        state,
      }).then((res) => {
        if (res.code === 200) {
          window.location.href = res.data;
        }
      });
    }

    if (this.weixinFlag) {
      return;
    }

    await this.getIndividualSurveys(); // 获取最新公告
    await getExchangeHistory().then((res) => {
      if (res.code === 200) {
        this.changesList = res.data;
        console.log("this.changesList", this.changesList);
      }
    });
  },
};
</script>


<style lang="scss" scoped>
.main {
  background-color: #f8f8f8;
  padding-bottom: 50px;
  .content {
    padding: 0 15px;
    background-color: #f8f8f8;
    background-image: url("../../assets/mobile/image/common/shadow.png");
    background-size: cover;
    background-position: 100% 100%;
    background-repeat: no-repeat;
    padding-bottom: 20px;
    // 公告模块
    .notice-box {
      display: flex;
      padding: 10px 0;
      align-items: center;
      box-sizing: border-box;
      .notice-left {
        width: calc(100% - 36px);
        height: 34px;
        background: #ffffff;
        border-radius: 17px;
        color: #232323;
        font-size: 14px;
        display: flex;
        align-items: center;

        overflow: hidden;
        .horn {
          width: 18px;
          height: 18px;
          flex-shrink: 0;
          margin-right: 11px;
        }

        .default-box {
          display: flex;
          align-items: center;

          .default-item {
            display: flex;
            align-items: center;
            margin-right: 30px;
          }

          .default-img {
            width: 24px;
            height: 24px;
            border-radius: 12px;
            margin-right: 5px;
          }

          .tel-number {
            margin-right: 5px;
          }

          .dateline {
            margin-right: 5px;
          }

          .amount {
            span {
              color: #ffa200;
            }
          }
        }

        .notice-img {
          display: flex;
          align-items: center;
        }

        .van-notice-bar {
          width: 100% !important;
          background-color: #fff;
          color: #232323;
        }

        .notice {
          width: 18px;
          // margin: 0 11px 0 15px;
          flex-shrink: 0;
        }

        span {
          width: calc(100% - 44px);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .chat {
        flex-shrink: 0;
        width: 24px;
        margin-left: 12px;
        height: 24px;
      }
    }
    //快捷导航
    .quick-navigation {
      .bg1 {
        width: 100%;
        border-radius: 8px;
      }
      .quick-card {
        width: 100%;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        margin-top: 10px;
        display: flex;
        padding: 16px 15px 13px 15px;
        box-sizing: border-box;
        justify-content: space-between;
        .quick-item {
          width: 60px;
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: pointer;
          .iocn {
            width: 52px;
            height: 52px;
          }
          .name {
            text-align: center;
            font-size: 14px;
            color: #232323;
            font-weight: bolder;
            margin-top: 10px;
          }
        }
      }
    }
  }
  //推荐任务
  .task-list {
    background-color: #f8f8f8;
    padding: 0 15px;
    .task-herder {
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;
      .task-herder-left {
        color: #232323;
        font-size: 18px;
        font-weight: bolder;
      }
      .task-herder-right {
        color: #666666;
        font-size: 14px;
      }
    }
    .task-item {
      width: 100%;
      height: 82px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      .task-left {
        padding-left: 10px;
        display: flex;
        .edit {
          width: 46px;
          height: 46px;
          margin-top: 15px;
        }
      }
      .text-box {
        margin-left: 18px;
        .text-top {
          font-size: 16px;
          color: #232323;
          font-weight: bolder;
          margin-top: 13px;
          span {
            margin-right: 10px;
          }
        }
        .img-bottom {
          display: flex;
          margin-top: 15px;
          .star {
            width: 16px;
            height: 16px;
            margin-right: 3px;
          }
        }
      }
      .task-right {
        margin-right: 10px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        .shang {
          display: flex;
          img {
            width: 14px;
            height: 14px;
            margin-top: 15px;
            margin-left: 5px;
          }
        }
        .number-box {
          color: #232323;
          font-size: 12px;
          margin-top: 13px;
          .number {
            font-size: 20px;
            color: #ff6017;
            font-weight: bolder;
            margin-right: 5px;
          }
        }
      }
    }
  }
}

.empty-box {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>